import React, { useEffect, useState } from 'react';
import SavingSpinner from '../../../../Components/Base/Loading/SavingSpinner';
import { NCZI_LAST_STATE } from '../../Enums/ncziLastState.enum';
import {useNCZICommandContext} from "../../Services/NCZICommandContext";

export const STATUS_TRANSLATION: {[key: string]: string} = {
	[NCZI_LAST_STATE.EXECUTING]: 'nczi.state.creatingRequest',
	[NCZI_LAST_STATE.CREATED]: 'nczi.state.creatingRequest',
	[NCZI_LAST_STATE.ACCEPTED]: 'nczi.state.creatingRequest',
	[NCZI_LAST_STATE.WAITING_AUTH]: 'nczi.state.authorizationOfRequest',
	[NCZI_LAST_STATE.AUTHORIZED]: 'nczi.state.authorizationOfRequest',
	[NCZI_LAST_STATE.PATIENT_WAITING_AUTH]: 'nczi.state.patientAuthorizationOfRequest',
	[NCZI_LAST_STATE.PATIENT_AUTHORIZED]: 'nczi.state.patientAuthorizationOfRequest',
	[NCZI_LAST_STATE.MESSAGE_CREATED]: 'nczi.state.communicationRunning',
	[NCZI_LAST_STATE.MESSAGE_RECEIVED]: 'nczi.state.processingRequest',
	[NCZI_LAST_STATE.DONE]: 'nczi.state.loading',
	[NCZI_LAST_STATE.ERROR]: 'nczi.state.loading',
	[NCZI_LAST_STATE.OFFLINE]: 'nczi.state.offline',
	[NCZI_LAST_STATE.MANUAL]: 'nczi.state.manual',
};

interface NCZILoadingStatusParams {
	commandId: string
}

const NCZILoadingStatus: React.FC<NCZILoadingStatusParams> = (params) => {
	const [lastSupportStatus, setLastSupportedStatus] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const { commands } = useNCZICommandContext();

	useEffect(() => {
		const command = commands[params.commandId];
		if (command && command.state !== 'done' && command.state !== 'error') {
			if(STATUS_TRANSLATION[command.state]) {
				setLastSupportedStatus(STATUS_TRANSLATION[command.state]);
			}
			setIsLoading(true);
		} else {
			setIsLoading(false);
		}
	}, [commands, params.commandId]);

	return (
		<>
			{isLoading && lastSupportStatus && (
				<SavingSpinner tx={lastSupportStatus} />
			)}
		</>
	);
};

export default NCZILoadingStatus;
